import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { ScaffoldForRegularModule } from '@shared/core/components/scaffold/scaffoldTypes/forRegular';

import { AppModeRootGuard } from '@shared/core/guards/app-mode-root.shared.guard';
import { AuthorizationGuard } from '@shared/core/guards/authorization.shared.guard';
import { CheckoutGuard } from '@shared/core/guards/checkout.shared.guard';
import { AppModeOrderingGuard } from '@shared/core/guards/app-mode-ordering.shared.guard';
import { GUIDGuard } from '@shared/core/guards/guid.shared.guard';

import { DrawExpandResolver, DrawCollapseResolver } from '@shared/core/directives/drawCollapse';

import { ViewsComponent } from './views.component';
import { CONFIG } from '@tolo/config';

const startRoutes = (CONFIG.isLiveViewEnabled) ? [{
    path: 'order-confirmation',
    loadChildren: () => import('./OrderConfirmation/order-confirmation.module').then(m => m.OrderConfirmationModule),
    canActivate: [
        AppModeOrderingGuard
    ],
}] : [];

const routes: Route[] = [
    {
        path: '',
        component: ViewsComponent,

        children: [
            ...startRoutes,
            {
                path: '',
                loadChildren: () => import('./Home/home.module').then(m => m.HomeModule),
                pathMatch: 'full',
                canActivate: [
                    AppModeRootGuard
                ],
                resolve: [
                    DrawExpandResolver
                ],
                data: { animation: 'HomePage' },
            },
            {
                path: 'loyalty',
                loadChildren: () => import('./Loyalty/loyalty.module').then(m => m.LoyaltyModule),
                canActivate: [
                    AppModeRootGuard
                ],
                resolve: [
                    DrawExpandResolver
                ],
                data: { animation: 'Account' },
            },
            {
                path: 'account',
                loadChildren: () => import('./Account/account.module').then(m => m.AccountModule),
                canActivate: [
                    AuthorizationGuard
                ],
                resolve: [
                    DrawExpandResolver
                ],
                data: { animation: 'Account' },
            },
            {
                path: 'checkout',
                loadChildren: () => import('./Checkout/checkout.module').then(m => m.CheckoutModule),
                canActivate: [
                    AppModeOrderingGuard,
                    CheckoutGuard
                ],
                data: { animation: 'Checkout' },
            },
            {
                path: 'locations',
                loadChildren: () => import('./Locations/locations.module').then(m => m.LocationsModule),
                data: { animation: 'Locations' },
                canActivate: [
                    AppModeOrderingGuard
                ],
            },
            {
                path: 'reset-password',
                loadChildren: () => import('./ResetPassword/reset-password.module').then(m => m.ResetPasswordModule),
                pathMatch: 'full',
                resolve: [
                    DrawCollapseResolver
                ],
                canActivate: [
                    GUIDGuard
                ],
                data: { animation: 'ResetPassword' },
            },
            {
                path: 'email-confirmation',
                loadChildren: () => import('./EmailConfirmation/email-confirmation.module').then(m => m.EmailConfirmationModule),
                canActivate: [GUIDGuard],
                resolve: [
                    DrawCollapseResolver
                ],
                data: { animation: 'EmailConfirmation' },
            },
            {
                path: 'VENUE_DYNAMIC_URL',
                loadChildren: () => import('./Locations/locations.module').then(m => m.LocationsModule),
                data: { animation: 'Locations' },
                canActivate: [
                    AppModeOrderingGuard
                ],
            },
            {
                path: '404',
                loadChildren: () => import('./Error404/error404.module').then(m => m.Error404Module),
                pathMatch: 'full',
                resolve: [
                    DrawExpandResolver
                ],
                data: { animation: 'Error404' },
            },
        ]
    }

];

@NgModule({
    declarations: [
        ViewsComponent,
    ],
    imports: [
        ScaffoldForRegularModule,
        RouterModule.forChild(routes),
    ],
})
export class ViewsModule {
}
